import { useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useLocation } from "react-router-dom";

import { DesktopHeader } from "components/page-header/desktop-header";
import { MobileHeader } from "components/page-header/mobile-header";
import { screenSizes } from "consts";
import { useUser } from "data/ss-data-hooks";
import { getPageMetadata } from "utils";

type PageHeaderProps = {
  hideNavigation?: boolean;
  hidePolicyHeader?: boolean;
  tabs?: Record<string, string>[];
};

export const PageHeader = ({
  hideNavigation,
  hidePolicyHeader,
  tabs,
}: PageHeaderProps) => {
  const { pathname } = useLocation();
  const userInfo = useUser();
  const pageTitle = getPageMetadata(pathname, userInfo?.firstName).displayTitle;

  const isMobile = useMediaQuery({
    maxWidth: screenSizes.laptop,
  });

  const [isPolicyDrawerOpen, setIsPolicyDrawerOpen] = useState(false);

  return isMobile ? (
    <MobileHeader
      hidePolicyHeader={hidePolicyHeader}
      tabs={tabs}
      pageTitle={pageTitle}
      isPolicyDrawerOpen={isPolicyDrawerOpen}
      onPolicyDrawerOpen={() => setIsPolicyDrawerOpen(true)}
      onPolicyDrawerClose={() => setIsPolicyDrawerOpen(false)}
    />
  ) : (
    <DesktopHeader
      hideNavigation={hideNavigation}
      hidePolicyHeader={hidePolicyHeader}
      tabs={tabs}
      pageTitle={pageTitle}
      isPolicyDrawerOpen={isPolicyDrawerOpen}
      onPolicyDrawerOpen={() => setIsPolicyDrawerOpen(true)}
      onPolicyDrawerClose={() => setIsPolicyDrawerOpen(false)}
    />
  );
};
